import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { CloseOnOutsideDirective } from '@awread/global/packages';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPen, faSortDown } from '@fortawesome/free-solid-svg-icons';

@Component({
  standalone: true,
  selector: 'atom-dropdown-free-chapter',
  imports: [CloseOnOutsideDirective, CommonModule, FontAwesomeModule],
  templateUrl: './dropdown-free-chapter.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
      :host .shadow-dropdown {
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownFreeChapterAtom implements OnInit {
  setFreeChapters = [
    {
      text: 'Đọc thử 1 chương',
      value: '1',
    },
    {
      text: 'Đọc thử 3 chương',
      value: '1,2,3',
    },
    {
      text: 'Đọc thử 5 chương',
      value: '1,2,3,4,5',
    },
    {
      text: 'Đọc thử 10 chương',
      value: '1,2,3,4,5,6,7,8,9,10',
    },
  ];
  @Input() book!: any;
  @Input() index!: number;
  @Output() action = new EventEmitter();
  isDropdown = false;
  faIcon = faSortDown;
  faPen = faPen;
  constructor() {}

  ngOnInit(): void {}

  openDropdown() {
    this.isDropdown = !this.isDropdown;
  }
  closeDropdown() {
    this.isDropdown = false;
  }
}
